<template lang="pug">
.feedback-form-setup
  v-row(no-gutters)
    v-col.mr-8
      v-row(no-gutters)
        v-col
          .title.mb-8
            .text-md.font-medium {{ $t('feedback_form') }}
            .text-sm.neutral700--text.font-normal {{ $t('feedback_form_description_2') }}
        v-spacer
        v-col.text-right.shrink
          v-btn.mt-1.button-sm(color="neutral700" dark depressed @click="openFeedbackFormDialog = true") {{ $t('add_new_question') }}
      
      .data-table
        v-data-table.pb-6(ref="table" :headers="headers" :items="fetchingData" item-key="id" hide-default-footer item-class="text-sm" disable-sort :header-props="{ sortIcon: '$yzi-triangle' }" disable-pagination)
          template(v-slot:body="props")
            draggable(v-if="isTableMounted && $refs.table" :list="fetchingData" tag="tbody" handle=".handle" draggable=".can-drag" @start="drag = true" @end="endDrag")
              v-nodes(:vnodes="$refs.table.genItems(props.items, props)")
          template(v-slot:item="{ item, headers, index }")
            tr.primary--text(:class="item.default ? '' : 'can-drag'")
              template(v-for="header in headers")
                template(v-if="header.value === 'handle'")
                  td.py-4
                    div.d-flex(v-if="item.default")
                      v-icon.ma-0(color="neutral300") $yzi-dots-grid-02
                    div.d-flex.handle.cursor-grab(v-else)
                      v-icon.ma-0(color="neutral500") $yzi-dots-grid-02
                template(v-else-if="header.value === 'actions'")
                  td.py-4
                    div.d-flex.align-center.justify-end
                      v-btn.button-xs.mr-1(color="neutral700" dark outlined @click="editItem(item, index)") {{ $t('edit') }}
                      v-btn.button-xs(icon color="neutral700" :disabled="item.default" @click="deleteItem(item, index)")
                        v-icon(size="20") $yzi-trash-03
                template(v-else-if="header.value === 'type'")
                  td.py-4
                    .d-flex.align-center
                      feedback-icon-display.mr-2(:type="item.type")
                      .text-xs.font-normal {{ types[item.type] | truncate(5) }}
                template(v-else-if="header.value === 'required'")
                  td.py-4
                    .d-flex.align-center
                      template(v-if="item.required")
                        v-icon.mr-1(size="20" color="success500") mdi-check-circle
                        .text-xs.font-normal {{ $t('on') }}
                      template(v-else)
                        v-icon.mr-1(size="20" color="neutral500") mdi-check-circle
                        .text-xs.font-normal {{ $t('off') }}
                template(v-else-if="header.value === 'enabled'")
                  td.py-4
                    .d-flex.align-center
                      template(v-if="item.enabled")
                        v-btn.button-xs.button-xs-spacing(depressed color="success100" @click="toggleStatus(item, index)")
                          .d-flex.align-center
                            v-icon.mr-1(size="8" color="success700") mdi-circle
                            .success700--text.font-normal.text-sm {{ $t('active') }}
                      template(v-else)
                        v-btn.button-xs.button-xs-spacing(depressed color="danger100" @click="toggleStatus(item, index)")
                          .d-flex.align-center
                            v-icon.mr-1(size="8" color="danger700") mdi-circle
                            .danger700--text.font-normal.text-sm {{ $t('inactive') }}
                template(v-else)
                  td.py-4.text-sm {{ item[header.id.toLowerCase()] }}
    //- Preview
    v-col(v-if="!isMobileScreen" cols="4")
      .sticky.mb-4
        feedback-form-setup-preview(:resizeImageFileUrl="resizeImageFileUrl" :formFields="fetchingData")
  .dialogs
    edit-feedback-form-dialog(v-if="openFeedbackFormDialog" :open.sync="openFeedbackFormDialog" :allFields="fetchingData" :field="selectedItem" :fieldIndex="selectedIndex" @closed="resetItem" @updated="mapData")
    delete-confirmation-dialog(v-if="openDeleteConfirmationDialog" :open.sync="openDeleteConfirmationDialog" item="question" :isLoading="isDeleting" @cancel="resetItem" @delete="deleteAction")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EditFeedbackFormDialog from '@/components/review/dialogs/EditFeedbackFormDialog.vue'
import FeedbackIconDisplay from '@/components/review/general/FeedbackIconDisplay.vue';
import DeleteConfirmationDialog from '@/components/review/dialogs/DeleteConfirmationDialog.vue';
import FeedbackFormSetupPreview from '@/components/review/settings/FeedbackFormSetupPreview.vue'
import draggable from 'vuedraggable'

export default {
  name: 'FeedbackFormSetup',
  components: {
    EditFeedbackFormDialog, FeedbackIconDisplay, DeleteConfirmationDialog, FeedbackFormSetupPreview, draggable,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    }
  },
  props: {
    fetchingData: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data () {
    return {
      types:{
        text: 'Short answer', 
        radiobtn: 'Multiple choice',
        checklist: 'Multiple choice',
        phone: 'Phone number',
        number: 'Number only', 
        address: 'Address',
        long_text: 'Paragraph',
        date: 'Date',
        email: 'Email'
      },
      selectedIndex: null,
      selectedItem: null,
      openFeedbackFormDialog: false,
      openDeleteConfirmationDialog: false,
      isDeleting: false,
      drag: false,
      isTableMounted: false,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      reviewSettings: 'review/getSettings',
      feedbackFormFields: 'review/getFeedbackFormFields'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers() {
      const fields = this.feedbackFormFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
        item['class'] = 'text-xs font-bold neutral500--text text-uppercase'
      })
      const actions = {
        text: 'Action',
        value: 'actions',
        enable: true,
        class: 'text-xs font-bold text-end neutral500--text text-uppercase',
        sortable: false
      }
      return [...fields, actions]
    },
    resizeImageFileUrl() {
      return this.reviewSettings.company_logo?.file
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.isTableMounted = true
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    mapData(data) {
      this.fetchingData = this.fetchingData.splice(data.idx, 1, data)
    },
    resetItem() {
      this.selectedItem = null
      this.selectedIndex = null
    },
    editItem(item, index) {
      this.selectedIndex = index
      this.selectedItem = item
      this.openFeedbackFormDialog = true
    },
    deleteItem(item, index) {
      this.selectedIndex = index
      this.selectedItem = item
      this.openDeleteConfirmationDialog = true
    },
    async endDrag (event) {
      this.drag = false
      const prevPosition = event.oldIndex
      const newPosition = event.newIndex
      try {
        await this.$axios.post(`reviews/${this.company.slug}/form_fields/${prevPosition}/move`, { position: newPosition })
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.error_move_item', { item: 'question' }) ])
      }
    },
    async deleteAction() {
      this.isDeleting = true
      const index = this.selectedIndex
      try {
        await this.$axios.delete(`reviews/${this.company.slug}/form_fields/${index}`)
        this.fetchingData = this.fetchingData.splice(index, 1)
        this.showMessage(['success', this.$t('success_message.delete_successful')])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isDeleting = false
        this.openDeleteConfirmationDialog = false
        this.resetItem()
      }
    },
    async toggleStatus(item, index) {
      if (item.default) {
        return
      }
      const data = { enabled: !item.enabled }
      try {
        const resp = await this.$axios.patch(`reviews/${this.company.slug}/form_fields/${index}`, data)
        this.mapData(resp.data)
        this.showMessage(['success', this.$t('success_message.update_successful')])
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isDeleting = false
        this.openDeleteConfirmationDialog = false
      }
    }
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.no-padding-x {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}
::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.pre-wrap {
  white-space: pre-wrap;
}
.sticky {
  top: 1%;
  position: sticky;
}
.adjust-margin {
  margin-top: -6px !important;
}
::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}
.button-xs-spacing {
  padding-left: 8px !important;
  padding-right: 8px !important;
  height: 25px !important;
}
</style>
